// -------------------------------------------------------------------------------

// PLEASE DO NOT EDIT THIS FILE, IT IS GENERATED AND WILL BE OVERWRITTEN:
// https://github.com/ccxt/ccxt/blob/master/CONTRIBUTING.md#how-to-contribute-code

// -------------------------------------------------------------------------------

import { Dict, List } from '../base/types.js';
import { Exchange as _Exchange } from '../base/Exchange.js';

interface Exchange {
    v1PubGetHistKline (params?: {}): Promise<Dict>;
    v1PubGetHistTrades (params?: {}): Promise<Dict>;
    v1PublicGetInfo (params?: {}): Promise<Dict>;
    v1PublicGetInfoSymbol (params?: {}): Promise<Dict>;
    v1PublicGetSystemInfo (params?: {}): Promise<Dict>;
    v1PublicGetMarketTrades (params?: {}): Promise<Dict>;
    v1PublicGetToken (params?: {}): Promise<Dict>;
    v1PublicGetTokenNetwork (params?: {}): Promise<Dict>;
    v1PublicGetFundingRates (params?: {}): Promise<Dict>;
    v1PublicGetFundingRateSymbol (params?: {}): Promise<Dict>;
    v1PublicGetFundingRateHistory (params?: {}): Promise<Dict>;
    v1PublicGetFutures (params?: {}): Promise<Dict>;
    v1PublicGetFuturesSymbol (params?: {}): Promise<Dict>;
    v1PublicGetOrderbookSymbol (params?: {}): Promise<Dict>;
    v1PublicGetKline (params?: {}): Promise<Dict>;
    v1PrivateGetClientToken (params?: {}): Promise<Dict>;
    v1PrivateGetOrderOid (params?: {}): Promise<Dict>;
    v1PrivateGetClientOrderClientOrderId (params?: {}): Promise<Dict>;
    v1PrivateGetOrders (params?: {}): Promise<Dict>;
    v1PrivateGetClientTradeTid (params?: {}): Promise<Dict>;
    v1PrivateGetOrderOidTrades (params?: {}): Promise<Dict>;
    v1PrivateGetClientTrades (params?: {}): Promise<Dict>;
    v1PrivateGetClientHistTrades (params?: {}): Promise<Dict>;
    v1PrivateGetStakingYieldHistory (params?: {}): Promise<Dict>;
    v1PrivateGetClientHolding (params?: {}): Promise<Dict>;
    v1PrivateGetAssetDeposit (params?: {}): Promise<Dict>;
    v1PrivateGetAssetHistory (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountAll (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountAssets (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountAssetDetail (params?: {}): Promise<Dict>;
    v1PrivateGetSubAccountIpRestriction (params?: {}): Promise<Dict>;
    v1PrivateGetAssetMainSubTransferHistory (params?: {}): Promise<Dict>;
    v1PrivateGetTokenInterest (params?: {}): Promise<Dict>;
    v1PrivateGetTokenInterestToken (params?: {}): Promise<Dict>;
    v1PrivateGetInterestHistory (params?: {}): Promise<Dict>;
    v1PrivateGetInterestRepay (params?: {}): Promise<Dict>;
    v1PrivateGetFundingFeeHistory (params?: {}): Promise<Dict>;
    v1PrivateGetPositions (params?: {}): Promise<Dict>;
    v1PrivateGetPositionSymbol (params?: {}): Promise<Dict>;
    v1PrivateGetClientTransactionHistory (params?: {}): Promise<Dict>;
    v1PrivateGetClientFuturesLeverage (params?: {}): Promise<Dict>;
    v1PrivatePostOrder (params?: {}): Promise<Dict>;
    v1PrivatePostOrderCancelAllAfter (params?: {}): Promise<Dict>;
    v1PrivatePostAssetLtv (params?: {}): Promise<Dict>;
    v1PrivatePostAssetInternalWithdraw (params?: {}): Promise<Dict>;
    v1PrivatePostInterestRepay (params?: {}): Promise<Dict>;
    v1PrivatePostClientAccountMode (params?: {}): Promise<Dict>;
    v1PrivatePostClientPositionMode (params?: {}): Promise<Dict>;
    v1PrivatePostClientLeverage (params?: {}): Promise<Dict>;
    v1PrivatePostClientFuturesLeverage (params?: {}): Promise<Dict>;
    v1PrivatePostClientIsolatedMargin (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteClientOrder (params?: {}): Promise<Dict>;
    v1PrivateDeleteOrders (params?: {}): Promise<List>;
    v1PrivateDeleteAssetWithdraw (params?: {}): Promise<Dict>;
    v3PublicGetSystemInfo (params?: {}): Promise<Dict>;
    v3PublicGetInstruments (params?: {}): Promise<Dict>;
    v3PublicGetToken (params?: {}): Promise<Dict>;
    v3PublicGetTokenNetwork (params?: {}): Promise<Dict>;
    v3PublicGetTokenInfo (params?: {}): Promise<Dict>;
    v3PublicGetMarketTrades (params?: {}): Promise<Dict>;
    v3PublicGetMarketTradesHistory (params?: {}): Promise<Dict>;
    v3PublicGetOrderbook (params?: {}): Promise<Dict>;
    v3PublicGetKline (params?: {}): Promise<Dict>;
    v3PublicGetKlineHistory (params?: {}): Promise<Dict>;
    v3PublicGetFutures (params?: {}): Promise<Dict>;
    v3PublicGetFundingRate (params?: {}): Promise<Dict>;
    v3PublicGetFundingRateHistory (params?: {}): Promise<Dict>;
    v3PublicGetInsuranceFund (params?: {}): Promise<Dict>;
    v3PrivateGetTradeOrder (params?: {}): Promise<Dict>;
    v3PrivateGetTradeOrders (params?: {}): Promise<Dict>;
    v3PrivateGetTradeAlgoOrder (params?: {}): Promise<Dict>;
    v3PrivateGetTradeAlgoOrders (params?: {}): Promise<Dict>;
    v3PrivateGetTradeTransaction (params?: {}): Promise<Dict>;
    v3PrivateGetTradeTransactionHistory (params?: {}): Promise<Dict>;
    v3PrivateGetTradeTradingFee (params?: {}): Promise<Dict>;
    v3PrivateGetAccountInfo (params?: {}): Promise<Dict>;
    v3PrivateGetAccountTokenConfig (params?: {}): Promise<Dict>;
    v3PrivateGetAccountSymbolConfig (params?: {}): Promise<Dict>;
    v3PrivateGetAccountSubAccountsAll (params?: {}): Promise<Dict>;
    v3PrivateGetAccountReferralSummary (params?: {}): Promise<Dict>;
    v3PrivateGetAccountReferralRewardHistory (params?: {}): Promise<Dict>;
    v3PrivateGetAccountCredentials (params?: {}): Promise<Dict>;
    v3PrivateGetAssetBalances (params?: {}): Promise<Dict>;
    v3PrivateGetAssetTokenHistory (params?: {}): Promise<Dict>;
    v3PrivateGetAssetTransferHistory (params?: {}): Promise<Dict>;
    v3PrivateGetAssetWalletHistory (params?: {}): Promise<Dict>;
    v3PrivateGetAssetWalletDeposit (params?: {}): Promise<Dict>;
    v3PrivateGetAssetStakingYieldHistory (params?: {}): Promise<Dict>;
    v3PrivateGetFuturesPositions (params?: {}): Promise<Dict>;
    v3PrivateGetFuturesLeverage (params?: {}): Promise<Dict>;
    v3PrivateGetFuturesDefaultMarginMode (params?: {}): Promise<Dict>;
    v3PrivateGetFuturesFundingFeeHistory (params?: {}): Promise<Dict>;
    v3PrivateGetSpotMarginInterestRate (params?: {}): Promise<Dict>;
    v3PrivateGetSpotMarginInterestHistory (params?: {}): Promise<Dict>;
    v3PrivateGetSpotMarginMaxMargin (params?: {}): Promise<Dict>;
    v3PrivateGetAlgoOrderOid (params?: {}): Promise<Dict>;
    v3PrivateGetAlgoOrders (params?: {}): Promise<Dict>;
    v3PrivateGetPositions (params?: {}): Promise<Dict>;
    v3PrivateGetBuypower (params?: {}): Promise<Dict>;
    v3PrivateGetConvertExchangeInfo (params?: {}): Promise<Dict>;
    v3PrivateGetConvertAssetInfo (params?: {}): Promise<Dict>;
    v3PrivateGetConvertRfq (params?: {}): Promise<Dict>;
    v3PrivateGetConvertTrade (params?: {}): Promise<Dict>;
    v3PrivateGetConvertTrades (params?: {}): Promise<Dict>;
    v3PrivatePostTradeOrder (params?: {}): Promise<Dict>;
    v3PrivatePostTradeAlgoOrder (params?: {}): Promise<Dict>;
    v3PrivatePostTradeCancelAllAfter (params?: {}): Promise<Dict>;
    v3PrivatePostAccountTradingMode (params?: {}): Promise<Dict>;
    v3PrivatePostAccountListenKey (params?: {}): Promise<Dict>;
    v3PrivatePostAssetTransfer (params?: {}): Promise<Dict>;
    v3PrivatePostAssetWalletWithdraw (params?: {}): Promise<Dict>;
    v3PrivatePostSpotMarginLeverage (params?: {}): Promise<Dict>;
    v3PrivatePostSpotMarginInterestRepay (params?: {}): Promise<Dict>;
    v3PrivatePostAlgoOrder (params?: {}): Promise<Dict>;
    v3PrivatePostConvertRft (params?: {}): Promise<Dict>;
    v3PrivatePutTradeOrder (params?: {}): Promise<Dict>;
    v3PrivatePutTradeAlgoOrder (params?: {}): Promise<Dict>;
    v3PrivatePutFuturesLeverage (params?: {}): Promise<Dict>;
    v3PrivatePutFuturesPositionMode (params?: {}): Promise<Dict>;
    v3PrivatePutOrderOid (params?: {}): Promise<Dict>;
    v3PrivatePutOrderClientClientOrderId (params?: {}): Promise<Dict>;
    v3PrivatePutAlgoOrderOid (params?: {}): Promise<Dict>;
    v3PrivatePutAlgoOrderClientClientOrderId (params?: {}): Promise<Dict>;
    v3PrivateDeleteTradeOrder (params?: {}): Promise<Dict>;
    v3PrivateDeleteTradeOrders (params?: {}): Promise<Dict>;
    v3PrivateDeleteTradeAlgoOrder (params?: {}): Promise<Dict>;
    v3PrivateDeleteTradeAlgoOrders (params?: {}): Promise<Dict>;
    v3PrivateDeleteTradeAllOrders (params?: {}): Promise<Dict>;
    v3PrivateDeleteAlgoOrderOrderId (params?: {}): Promise<Dict>;
    v3PrivateDeleteAlgoOrdersPending (params?: {}): Promise<Dict>;
    v3PrivateDeleteAlgoOrdersPendingSymbol (params?: {}): Promise<Dict>;
    v3PrivateDeleteOrdersPending (params?: {}): Promise<Dict>;
}
abstract class Exchange extends _Exchange {}

export default Exchange
